import React from 'react';

import {blogData} from "../data/blog/blogData";
import {Link} from 'react-router-dom'

import './styles/BlogList.scss'

import dayjs from 'dayjs'
import 'dayjs/locale/ru' // Подключение локализации

function BlogList(props) {

    const formatDate = (dateString) => {
        return dayjs(dateString).locale('ru').format('D MMMM YYYY');
    };

    return (
        <div>
            <h1>Блог Кибернетика</h1>

            <div className={'blog-list'}>
                {blogData.map((el, index) => {
                    return (
                        <div key={index} className={'blog-list__item'}>
                            <div className={'blog-list-item__header'}>
                                <h2>{el.title} </h2>
                                <p className={'tp-thin'}>{formatDate(el.createdAt)}</p>
                            </div>
                            <p>{el.description}</p>

                            <Link to={`/blog/${el.id}`}>Читать новость</Link>


                        </div>
                    )
                })}
            </div>
        </div>
    );
}

export default BlogList;